import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { PageHeader } from '../components/PageHeader';
import { NewsletterSection } from '../components/NewsletterSection';
import { Link } from 'react-router-dom';
import { Button } from '../components/Button';
import { CheckCircle, Heart, Users, Briefcase, Mail, Phone, User } from 'lucide-react';
export function GetInvolvedPage() {
  const [activeForm, setActiveForm] = useState<'volunteer' | 'partner' | null>(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [volunteerData, setVolunteerData] = useState({
    name: '',
    email: '',
    phone: '',
    skills: '',
    availability: '',
    message: ''
  });
  const [partnerData, setPartnerData] = useState({
    organization: '',
    contactName: '',
    email: '',
    phone: '',
    partnershipType: '',
    message: ''
  });
  const handleVolunteerSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
      setVolunteerData({
        name: '',
        email: '',
        phone: '',
        skills: '',
        availability: '',
        message: ''
      });
      setTimeout(() => {
        setIsSubmitted(false);
        setActiveForm(null);
      }, 5000);
    }, 1500);
  };
  const handlePartnerSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
      setPartnerData({
        organization: '',
        contactName: '',
        email: '',
        phone: '',
        partnershipType: '',
        message: ''
      });
      setTimeout(() => {
        setIsSubmitted(false);
        setActiveForm(null);
      }, 5000);
    }, 1500);
  };
  return <div className="font-sans bg-warm-ivory min-h-screen w-full" data-id="element-541">
      <Header data-id="element-542" />
      <main className="w-full font-sans" data-id="element-543">
        <PageHeader title="Get Involved" subtitle="Join us in our mission to uplift lives and transform communities" badgeText="JOIN OUR CAUSE" bgColor="bg-gradient-to-r from-sfrr-blue to-sfrr-pink" data-id="element-544" />

        {/* Ways to Get Involved */}
        <section className="py-16 bg-white" data-id="element-545">
          <div className="container mx-auto px-4" data-id="element-546">
            <div className="text-center mb-12" data-id="element-547">
              <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-548">
                Ways to Support Our Mission
              </h2>
              <p className="max-w-2xl mx-auto text-charcoal/80" data-id="element-549">
                There are many ways you can contribute to our cause and help
                make a difference in the lives of those we serve.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-550">
              {/* Donate */}
              <div className="bg-warm-ivory rounded-lg p-6 shadow-soft text-center hover:shadow-hover transition-all duration-300 hover:-translate-y-1" data-id="element-551">
                <div className="bg-sfrr-pink/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-552">
                  <Heart className="h-8 w-8 text-sfrr-pink" data-id="element-553" />
                </div>
                <h3 className="text-xl font-bold text-charcoal mb-2" data-id="element-554">Donate</h3>
                <p className="text-charcoal/80 mb-4" data-id="element-555">
                  Your financial contribution helps us implement our programs
                  and reach more communities in need.
                </p>
                <Link to="/donate" data-id="element-556">
                  <Button variant="primary" size="sm" data-id="element-557">
                    Donate Now
                  </Button>
                </Link>
              </div>

              {/* Volunteer */}
              <div className="bg-warm-ivory rounded-lg p-6 shadow-soft text-center hover:shadow-hover transition-all duration-300 hover:-translate-y-1" data-id="element-558">
                <div className="bg-sfrr-green/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-559">
                  <Users className="h-8 w-8 text-sfrr-green" data-id="element-560" />
                </div>
                <h3 className="text-xl font-bold text-charcoal mb-2" data-id="element-561">
                  Volunteer
                </h3>
                <p className="text-charcoal/80 mb-4" data-id="element-562">
                  Contribute your time and skills to support our programs and
                  make a direct impact on communities.
                </p>
                <Button variant="secondary" size="sm" onClick={() => setActiveForm('volunteer')} data-id="element-563">
                  Register as Volunteer
                </Button>
              </div>

              {/* Partner with Us */}
              <div className="bg-warm-ivory rounded-lg p-6 shadow-soft text-center hover:shadow-hover transition-all duration-300 hover:-translate-y-1" data-id="element-564">
                <div className="bg-sfrr-blue/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-565">
                  <Briefcase className="h-8 w-8 text-sfrr-blue" data-id="element-566" />
                </div>
                <h3 className="text-xl font-bold text-charcoal mb-2" data-id="element-567">
                  Partner with Us
                </h3>
                <p className="text-charcoal/80 mb-4" data-id="element-568">
                  Collaborate with us as an organization to create greater
                  impact through strategic partnerships.
                </p>
                <Button variant="primary" size="sm" onClick={() => setActiveForm('partner')} data-id="element-569">
                  Become a Partner
                </Button>
              </div>
            </div>
          </div>
        </section>

        {/* Volunteer Form Modal */}
        {activeForm === 'volunteer' && <section className="py-16 bg-warm-ivory" data-id="element-570">
            <div className="container mx-auto px-4" data-id="element-571">
              <div className="max-w-2xl mx-auto bg-white rounded-2xl p-8 shadow-2xl" data-id="element-572">
                {!isSubmitted ? <>
                    <div className="text-center mb-8" data-id="element-573">
                      <div className="w-16 h-16 bg-sfrr-green/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-574">
                        <Users className="w-8 h-8 text-sfrr-green" data-id="element-575" />
                      </div>
                      <h2 className="text-2xl md:text-3xl font-bold text-charcoal mb-2" data-id="element-576">
                        Volunteer Registration
                      </h2>
                      <p className="text-gray-600" data-id="element-577">
                        Fill out the form below to join our volunteer team
                      </p>
                    </div>

                    <form onSubmit={handleVolunteerSubmit} className="space-y-6" data-id="element-578">
                      <div data-id="element-579">
                        <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-580">
                          <User className="inline w-4 h-4 mr-2" data-id="element-581" />
                          Full Name *
                        </label>
                        <input type="text" required value={volunteerData.name} onChange={e => setVolunteerData({
                    ...volunteerData,
                    name: e.target.value
                  })} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-sfrr-green focus:ring-2 focus:ring-sfrr-green/20 outline-none transition-all" placeholder="Enter your full name" data-id="element-582" />
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-583">
                        <div data-id="element-584">
                          <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-585">
                            <Mail className="inline w-4 h-4 mr-2" data-id="element-586" />
                            Email Address *
                          </label>
                          <input type="email" required value={volunteerData.email} onChange={e => setVolunteerData({
                      ...volunteerData,
                      email: e.target.value
                    })} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-sfrr-green focus:ring-2 focus:ring-sfrr-green/20 outline-none transition-all" placeholder="your@email.com" data-id="element-587" />
                        </div>

                        <div data-id="element-588">
                          <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-589">
                            <Phone className="inline w-4 h-4 mr-2" data-id="element-590" />
                            Phone Number *
                          </label>
                          <input type="tel" required value={volunteerData.phone} onChange={e => setVolunteerData({
                      ...volunteerData,
                      phone: e.target.value
                    })} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-sfrr-green focus:ring-2 focus:ring-sfrr-green/20 outline-none transition-all" placeholder="0803 330 4041" data-id="element-591" />
                        </div>
                      </div>

                      <div data-id="element-592">
                        <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-593">
                          Skills & Expertise *
                        </label>
                        <input type="text" required value={volunteerData.skills} onChange={e => setVolunteerData({
                    ...volunteerData,
                    skills: e.target.value
                  })} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-sfrr-green focus:ring-2 focus:ring-sfrr-green/20 outline-none transition-all" placeholder="e.g., Teaching, Healthcare, Agriculture" data-id="element-594" />
                      </div>

                      <div data-id="element-595">
                        <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-596">
                          Availability *
                        </label>
                        <select required value={volunteerData.availability} onChange={e => setVolunteerData({
                    ...volunteerData,
                    availability: e.target.value
                  })} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-sfrr-green focus:ring-2 focus:ring-sfrr-green/20 outline-none transition-all" data-id="element-597">
                          <option value="" data-id="element-598">Select availability</option>
                          <option value="weekends" data-id="element-599">Weekends Only</option>
                          <option value="weekdays" data-id="element-600">Weekdays Only</option>
                          <option value="flexible" data-id="element-601">Flexible</option>
                          <option value="full-time" data-id="element-602">Full Time</option>
                        </select>
                      </div>

                      <div data-id="element-603">
                        <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-604">
                          Additional Information
                        </label>
                        <textarea rows={4} value={volunteerData.message} onChange={e => setVolunteerData({
                    ...volunteerData,
                    message: e.target.value
                  })} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-sfrr-green focus:ring-2 focus:ring-sfrr-green/20 outline-none transition-all resize-none" placeholder="Tell us why you want to volunteer..." data-id="element-605" />
                      </div>

                      <div className="flex gap-4" data-id="element-606">
                        <Button type="submit" variant="secondary" size="lg" fullWidth isLoading={isSubmitting} disabled={isSubmitting} data-id="element-607">
                          {isSubmitting ? 'Submitting...' : 'Submit Application'}
                        </Button>
                        <Button type="button" variant="outline" size="lg" onClick={() => setActiveForm(null)} data-id="element-608">
                          Cancel
                        </Button>
                      </div>
                    </form>
                  </> : <div className="text-center py-8 animate-fadeIn" data-id="element-609">
                    <div className="w-16 h-16 bg-sfrr-green/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-610">
                      <CheckCircle className="w-10 h-10 text-sfrr-green" data-id="element-611" />
                    </div>
                    <h2 className="text-2xl md:text-3xl font-bold text-charcoal mb-4" data-id="element-612">
                      Application Submitted!
                    </h2>
                    <p className="text-gray-600 mb-6" data-id="element-613">
                      Thank you for your interest in volunteering with us. We'll
                      review your application and get back to you soon.
                    </p>
                  </div>}
              </div>
            </div>
          </section>}

        {/* Partner Form Modal */}
        {activeForm === 'partner' && <section className="py-16 bg-warm-ivory" data-id="element-614">
            <div className="container mx-auto px-4" data-id="element-615">
              <div className="max-w-2xl mx-auto bg-white rounded-2xl p-8 shadow-2xl" data-id="element-616">
                {!isSubmitted ? <>
                    <div className="text-center mb-8" data-id="element-617">
                      <div className="w-16 h-16 bg-sfrr-blue/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-618">
                        <Briefcase className="w-8 h-8 text-sfrr-blue" data-id="element-619" />
                      </div>
                      <h2 className="text-2xl md:text-3xl font-bold text-charcoal mb-2" data-id="element-620">
                        Partnership Inquiry
                      </h2>
                      <p className="text-gray-600" data-id="element-621">
                        Let's explore how we can work together
                      </p>
                    </div>

                    <form onSubmit={handlePartnerSubmit} className="space-y-6" data-id="element-622">
                      <div data-id="element-623">
                        <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-624">
                          Organization Name *
                        </label>
                        <input type="text" required value={partnerData.organization} onChange={e => setPartnerData({
                    ...partnerData,
                    organization: e.target.value
                  })} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-sfrr-blue focus:ring-2 focus:ring-sfrr-blue/20 outline-none transition-all" placeholder="Your organization name" data-id="element-625" />
                      </div>

                      <div data-id="element-626">
                        <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-627">
                          <User className="inline w-4 h-4 mr-2" data-id="element-628" />
                          Contact Person Name *
                        </label>
                        <input type="text" required value={partnerData.contactName} onChange={e => setPartnerData({
                    ...partnerData,
                    contactName: e.target.value
                  })} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-sfrr-blue focus:ring-2 focus:ring-sfrr-blue/20 outline-none transition-all" placeholder="Enter contact person name" data-id="element-629" />
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-630">
                        <div data-id="element-631">
                          <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-632">
                            <Mail className="inline w-4 h-4 mr-2" data-id="element-633" />
                            Email Address *
                          </label>
                          <input type="email" required value={partnerData.email} onChange={e => setPartnerData({
                      ...partnerData,
                      email: e.target.value
                    })} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-sfrr-blue focus:ring-2 focus:ring-sfrr-blue/20 outline-none transition-all" placeholder="contact@organization.com" data-id="element-634" />
                        </div>

                        <div data-id="element-635">
                          <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-636">
                            <Phone className="inline w-4 h-4 mr-2" data-id="element-637" />
                            Phone Number *
                          </label>
                          <input type="tel" required value={partnerData.phone} onChange={e => setPartnerData({
                      ...partnerData,
                      phone: e.target.value
                    })} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-sfrr-blue focus:ring-2 focus:ring-sfrr-blue/20 outline-none transition-all" placeholder="0803 330 4041" data-id="element-638" />
                        </div>
                      </div>

                      <div data-id="element-639">
                        <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-640">
                          Partnership Type *
                        </label>
                        <select required value={partnerData.partnershipType} onChange={e => setPartnerData({
                    ...partnerData,
                    partnershipType: e.target.value
                  })} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-sfrr-blue focus:ring-2 focus:ring-sfrr-blue/20 outline-none transition-all" data-id="element-641">
                          <option value="" data-id="element-642">Select partnership type</option>
                          <option value="funding" data-id="element-643">Funding Partner</option>
                          <option value="implementation" data-id="element-644">
                            Implementation Partner
                          </option>
                          <option value="technical" data-id="element-645">Technical Partner</option>
                          <option value="corporate" data-id="element-646">
                            Corporate Social Responsibility
                          </option>
                          <option value="other" data-id="element-647">Other</option>
                        </select>
                      </div>

                      <div data-id="element-648">
                        <label className="block text-sm font-medium text-charcoal mb-2" data-id="element-649">
                          Tell Us About Your Interest *
                        </label>
                        <textarea rows={4} required value={partnerData.message} onChange={e => setPartnerData({
                    ...partnerData,
                    message: e.target.value
                  })} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-sfrr-blue focus:ring-2 focus:ring-sfrr-blue/20 outline-none transition-all resize-none" placeholder="Describe your partnership proposal..." data-id="element-650" />
                      </div>

                      <div className="flex gap-4" data-id="element-651">
                        <Button type="submit" variant="primary" size="lg" fullWidth isLoading={isSubmitting} disabled={isSubmitting} data-id="element-652">
                          {isSubmitting ? 'Submitting...' : 'Submit Inquiry'}
                        </Button>
                        <Button type="button" variant="outline" size="lg" onClick={() => setActiveForm(null)} data-id="element-653">
                          Cancel
                        </Button>
                      </div>
                    </form>
                  </> : <div className="text-center py-8 animate-fadeIn" data-id="element-654">
                    <div className="w-16 h-16 bg-sfrr-blue/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-655">
                      <CheckCircle className="w-10 h-10 text-sfrr-blue" data-id="element-656" />
                    </div>
                    <h2 className="text-2xl md:text-3xl font-bold text-charcoal mb-4" data-id="element-657">
                      Inquiry Submitted!
                    </h2>
                    <p className="text-gray-600 mb-6" data-id="element-658">
                      Thank you for your interest in partnering with us. Our
                      team will review your proposal and contact you shortly.
                    </p>
                  </div>}
              </div>
            </div>
          </section>}

        <NewsletterSection data-id="element-659" />
      </main>
      <Footer data-id="element-660" />
    </div>;
}